import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpirationAdd',
  templateUrl: './ExpirationAdd.component.html',
  styleUrls: ['./ExpirationAdd.component.scss']
})
export class ExpirationAddComponent implements OnInit {

  constructor(
    private Expiration_Service:ExpirationService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewExpiration=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Day:new FormControl(null,Validators.required),
    })

    this.Nav_Service.CheckValidPage(19).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewExpiration:FormGroup;

  get_Form_Title(){
    return this.AddNewExpiration.get('Title') as FormControl;
  }

  get_Form_Day(){
    return this.AddNewExpiration.get('Day') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewExpiration(){
    var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    Record.code=this.get_Form_Day().value
    this.InProccessing=true
    this.Expiration_Service.AddExpiration(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewExpiration.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


}
